<template>
  <section>
    <div class="d-flex flex-wrap justify-center justify-sm-center" style="gap: 0px;">
      <div :class="dataClass" v-if="!mostrarCandidatosBolson">
        <v-btn
          style="text-transform: none"
          color="primary"
          outlined
          rounded
          width="120"
          @click="volver"
        >
          <strong>Volver</strong>
        </v-btn>
      </div>
      <!-- <div :class="dataClass" v-if="handleShowOption('delegar') && (!solicitud.es_delegado) && puedeVerBotones">
        <v-btn
          @click="$emit('input', { DialogDelegar: true })"
          color="#2196F3"
          class="btn-text ma-2"
          width="120"
          rounded
          outlined
        >
          Delegar
        </v-btn>
      </div> -->
      <div
        :class="dataClass"
        v-if="handleShowOption('rechazar') && puedeVerBotones"
      >
        <v-btn
          @click="$emit('input', { DialogRechazar: true })"
          color="#f25757"
          class="btn-text"
          width="120"
          rounded
          outlined
        >
          Rechazar
        </v-btn>
      </div>
      <div
        :class="dataClass"
        v-if="handleShowOption('observar') && puedeVerBotones"
      >
        <v-btn
          @click="$emit('input', { DialogObservar: true })"
          color="#f2a722"
          class="btn-text"
          width="120"
          rounded
          outlined
        >
          Observar
        </v-btn>
      </div>
      <div
        :class="dataClass"
        v-if="handleShowOption('avanzar') && puedeVerBotones"
      >
        <v-btn
          @click="$emit('input', { DialogAutorizar: true })"
          color="primary"
          class="btn-text"
          style="min-width: 120px;"
          rounded
        >
          {{ textoAprobacion }}
        </v-btn>
      </div>
      <div :class="dataClass" v-if="handleShowOption('cifrado')">
        <v-btn
          @click="$emit('input', { DialogUfi: true })"
          color="primary"
          class="btn-text"
          style="min-width: 120px;"
          rounded
        >
          {{ textoAprobacion }}
        </v-btn>
      </div>
      <div :class="dataClass" v-if="handleShowOption('bolsa_empleo') && puedeVerBotonesSegunTab && !mostrarCandidatosBolson">
        <v-btn
          @click="$emit('input', { DialogBolsaEmpleo: true })"
          color="primary"
          class="btn-text"
          style="min-width: 120px;"
          rounded
        >
          {{ textoAprobacion }}
        </v-btn>
      </div>
      <div
        :class="dataClass"
        v-if="handleShowOption('candidatos_elegibles') && solicitud?.posee_candidatos_elegibles && !mostrarCandidatosBolson"
      >
        <v-btn
          @click="verCandidatosElegibles()"
          color="primary"
          class="btn-text"
          style="min-width: 120px;"
          rounded
        >
          Candidatos elegibles
        </v-btn>
      </div>
      <template v-if="mostrarCandidatosBolson">
        <div :class="dataClass">
          <v-btn
            @click="volverDeCandidatosBolson()"
            color="primary"
            class="btn-text font-weight-bold"
            style="min-width: 120px;"
            rounded
            outlined
          >
            Volver
          </v-btn>
        </div>
        <div :class="dataClass">
          <v-btn
            @click="continuarProcesoBolson()"
            color="primary"
            class="btn-text"
            style="min-width: 120px;"
            rounded
          >
            Continuar con el proceso
          </v-btn>
        </div>
      </template>
    </div>
  </section>
</template>
<script>
import { mapState } from "vuex";
import jwtDecode from "jwt-decode";
import { decodeFase } from "@/utils/faseEncoding";

export default {
  props: {
    small: {
      type: Boolean,
      default: true
    },
    dataClass: {
      type: String,
      default: "ma-1 pa-1"
    },
    observado: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      textoAprobacion: "Aprobar",
      userDecoded: null,
      navegando: false
    };
  },
  computed: {
    ...mapState("solicitud", [
      "solicitud",
      "faseActual",
      "esFaseActivaUsuario",
      "idDelegadoEmpleadoPuesto",
      "mostrarCandidatosBolson",
      "candidatosBolsonSeleccionadosCount"
    ]),
    faseQuery() {
      return decodeFase(this.$route.query.fase);
    },
    puedeVerBotonesSegunTab(){
      if(this.solicitud?.boton_activo){
        return this.solicitud?.boton_activo;
      }
    },
    // Verifica si el usuario tiene permiso para ver los botones de acción
    puedeVerBotones() {
      // Si está navegando, ocultar todos los botones inmediatamente
      if (this.navegando) {
        return false;
      }
      // Si idDelegadoEmpleadoPuesto es null o no existe, mostrar botones normalmente
      if (!this.idDelegadoEmpleadoPuesto) {
        return true;
      }

      // Si el token no se ha decodificado aún, intentar decodificarlo
      if (!this.userDecoded) {
        const token = localStorage.getItem("token");
        if (token) {
          try {
            this.userDecoded = jwtDecode(token);
          } catch (error) {
            console.error("Error al decodificar el token en computed:", error);
            return false;
          }
        } else {
          return false;
        }
      }

      // Si existe un delegado, solo mostrar si el id del puesto del usuario coincide
      return this.userDecoded?.puesto?.id === this.idDelegadoEmpleadoPuesto;
    }
  },
  watch: {
    faseActual(newVal, oldVal) {
      this.$forceUpdate();
    },
    esFaseActivaUsuario(newVal, oldVal) {
      this.$forceUpdate();
    }
  },
  methods: {
    handleShowOption(option) {
      
      if (!this.esFaseActivaUsuario) {
        return false;
      }
      if(this.faseQuery && this.faseQuery !== this.faseActual) return false;
      const opciones = {
        rechazar: ["P13-F2", "P14-F4", "P15-F2", "P15-F4"],
        observar: ["P13-F2", "P14-F4", "P15-F2", "P15-F4"],
        avanzar: [
          "P13-F2",
          "P14-F2",
          "P14-F3",
          "P15-F2",
          "P15-F3",
          "P15-F6",
          "P14-F1",
          "P13-F1",
          "P15-F1"
        ],
        cifrado: ["P14-F4", "P15-F4"],
        bolsa_empleo: ["P13-F3", "P14-F5", "P15-F5"],
        enviar_firma: ["P16-F1"],
        delegar: ["P13-F2", "P15-F2"],
        candidatos_elegibles: ["P13-F3", "P14-F5", "P15-F5"]
      };

      const esAdscrita = [true, 1, "1", "true"].includes(this.solicitud?.es_adscrita);
      const esSedeCentral = [true, 1, "1", "true"].includes(this.solicitud?.sede_central);

      switch (this.faseActual) {
        case "P13-F3":
        case "P14-F5":
        case "P15-F5":
          this.textoAprobacion = "Enviar a bolsa de empleo";
          break;
        case "P14-F2":
          this.textoAprobacion = !esAdscrita && esSedeCentral ? "Enviar a titular" : "Enviar";
          break;
        case "P14-F3":
        case "P15-F6":
          this.textoAprobacion = "Enviar a UFI";
          break;
        case "P15-F3":
          if (esAdscrita || !esSedeCentral) {
            this.textoAprobacion = "Enviar";
          } else if (this.solicitud?.tipo_solicitud?.id === 3) {
            this.textoAprobacion = "Enviar a Titular";
          } else {
            this.textoAprobacion = "Enviar a UFI";
          }
          break;
        case "P14-F1":
        case "P13-F1":
        case "P15-F1":
          this.textoAprobacion = "Subsanar";
          break;
        default:
          this.textoAprobacion = "Aprobar";
      }

      return opciones[option]?.includes(this.faseActual) ?? false;
    },
    volver() {
      this.navegando = true;
      this.$store.dispatch("solicitud/clearDelegadoEmpleadoPuesto");
      this.$router.go(-1);
    },
    verCandidatosElegibles(){
      this.$store.dispatch("solicitud/setMostrarCandidatosBolson", true);
      this.temporalAlert({
        show: true,
        message: "Mostrando candidatos elegibles del bolsón",
        type: "success"
      })
    },
    volverDeCandidatosBolson() {
      this.$emit('input', { DialogVolverDeCandidatosBolson: true });
    },
    continuarProcesoBolson() {
      // const vacantesSolicitar = this.solicitud?.numero_vacantes || 1;

      if (this.candidatosBolsonSeleccionadosCount === 0) {
        this.temporalAlert({
          show: true,
          message: "Debe seleccionar al menos un candidato para continuar con el proceso",
          type: "warning"
        });
        return;
      }

      // if (this.candidatosBolsonSeleccionadosCount < vacantesSolicitar) {
      //   this.temporalAlert({
      //     show: true,
      //     message: `Debe seleccionar al menos ${vacantesSolicitar} candidato(s) para continuar con el proceso`,
      //     type: "warning"
      //   });
      //   return;
      // }

      this.$emit('input', { DialogContinuarProcesoBolson: true });
    }
  },
  created() {
    // Decodificar el token del localStorage
    const token = localStorage.getItem("token");
    if (token) {
      try {
        this.userDecoded = jwtDecode(token);
      } catch (error) {
        this.userDecoded = null;
      }
    }
  }
};
</script>
